import Vue from 'vue'

const mutationMethods = {
    PUSH_NOTIFICATION: 'push-notification'
}

export const notify = {
    namespaced: true,
    state: {
        notifications: []
    },
    actions: {
        pushNotification({commit}, payload) {
            commit(mutationMethods.PUSH_NOTIFICATION, payload)
        }
    },
    mutations: {
        [mutationMethods.PUSH_NOTIFICATION](state, payload) {
            Vue.set(state, 'notifications', [ ...state.notifications, payload] )
        }
    },
    getters: {
        getNotifications: state => state.notifications
    }
}